import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

import { TInitialState } from '../reducer';

/**
 * Get decoder entity by id
 * @param id
 */
export const getDecoderById = (
    id: number | undefined,
) => (state: TInitialState) => {
    if (id) {
        return state[EEntity.decoders][id];
    }

    return undefined;
};
